import React from "react";
import { useTranslation } from "react-i18next";
import { default as useFormContext } from "../../hooks/useUpdateFormContext";

const MartialStatus = () => {
  const { t } = useTranslation();
  const { data, handleChange } = useFormContext();

  const content = (
    <div className="flex flex-col">
      <label htmlFor="mr_status">
        {t("martial_status")} <span className="text-red-600">*</span>
      </label>
      <select
        id="mr_status"
        className="form-textbox"
        name="mr_status"
        value={data.mr_status}
        onChange={handleChange}
      >
        <option value="">{t("select")}</option>
        <option value={t("married")}>{t("married")}</option>
        <option value={t("divorced")}>{t("divorced")}</option>
        <option value={t("seperated")}>{t("seperated")}</option>
        <option value={t("widowed")}>{t("widowed")}</option>
        <option value={t("single_parent")}>{t("single_parent")}</option>
      </select>
    </div>
  );
  return content;
};

export default MartialStatus;
